const env = import.meta.env;

const buildNumber = env.VITE_CODEBUILD_BUILD_NUMBER;
const sentryEnv = env.VITE_SENTRY_ENV;
const projectId = env.VITE_PROJECT_ID;
const wafCaptcha = env.VITE_WAF_API_URL;
const wafApiKey = env.VITE_WAF_API_KEY;
const authRedirectUrlOrigins = env.VITE_AUTH_REDIRECT_URL_ORIGINS?.split(',')
  .map((origin: string) => origin.trim().toLowerCase())
  .filter(Boolean) ?? ['*'];
const ssoAuthorizeHosts = env.VITE_SSO_AUTHORIZE_HOSTS?.split(',')
  .map((host: string) => host.trim().toLowerCase())
  .filter(Boolean) ?? ['auth0.com'];

export const Config = {
  /** Project ID for public login. */
  projectId,
  /** Trusted Auth0 domains for SSO authorize redirects. */
  ssoAuthorizeHosts,
  /** Whitelisted web origins and mobile URL schemes for optional code auth redirect_url. "*" allows any http(s) URL. */
  authRedirectUrlOrigins,
  /** Base URL for API. */
  baseURL: env.VITE_BASE_URL,
  /** Login by guest ID */
  isLoginByGuestId: env.VITE_LOGIN_BY_GUEST_ID === 'true',
  /** AWS WAF */
  waf: {
    apiKey: wafApiKey,
    apiUrl: wafCaptcha,
    enabled: !!wafCaptcha && !!wafApiKey,
  },
  /** Languages for translation */
  supportedLanguages:
    env.VITE_SUPPORTED_LANGUAGES?.split(',')
      .map((lang) => lang.trim())
      .filter(Boolean) ?? [],
  /** Sentry  configuratiin **/
  sentry: {
    env: sentryEnv,
    dsn: env.VITE_SENTRY_DSN,
    release:
      sentryEnv && buildNumber
        ? `${sentryEnv}-${projectId}-${buildNumber}`
        : undefined,
  },
};
